import { z } from 'zod';
/**
 * The outside sources this product buys from.
 *
 * Split out of contract.ts, which carried the whole API contract in one file.
 * Nothing here changed on the way out.
 */
// ---------- Data providers -----------------------------------------------------
/**
 * The two data providers. Exactly one is active; the other is dormant, keeps its
 * key and keeps its own credit balance.
 *
 * These ids, and the capability shape below, are declared a second time in
 * backend/src/providers/types.ts, which is the seam the adapters implement.
 * Neither file can import the other: shared has no dependency on backend, and
 * this package is bundled into the browser. Two guards keep them in step —
 * backend/test/provider-contract.test.ts compares the id and label tables at
 * runtime, and the /api/me handler assigns each adapter's capabilities into the
 * ProviderStatus below, so a renamed or dropped capability fails the backend
 * build rather than reaching the Settings screen as a silently missing row.
 */
export const PROVIDER_IDS = ['enrichlayer', 'enrichmentapi', 'apollo'];
export const PROVIDER_LABEL = {
    enrichlayer: 'Enrich Layer',
    enrichmentapi: 'EnrichmentAPI',
    apollo: 'Apollo',
};
/**
 * Everywhere a value can have come from: the providers this product buys from,
 * and the CRM, which supplies facts for nothing.
 *
 * The CRM is a source and not a provider. Nothing can be bought from it, so it
 * never appears in Settings, on an Enrich button or in a cost table — but an
 * address it supplied has to say so beside the value exactly as a bought one
 * does, and a search it made unnecessary has to appear in the search log.
 */
export const SOURCE_IDS = [...PROVIDER_IDS, 'zoho_crm'];
export const SOURCE_LABEL = {
    ...PROVIDER_LABEL,
    zoho_crm: 'Zoho CRM',
};
export function isSourceId(id) {
    return SOURCE_IDS.includes(id ?? '');
}
export const SetActiveProviderRequestSchema = z.object({ providerId: z.enum(PROVIDER_IDS) });
//# sourceMappingURL=providers.js.map